import React, { useState } from 'react';
import { Alert, Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);
  const loading = useAuthStore((s) => s.loading);
  const error = useAuthStore((s) => s.error);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const submit = async () => {
    const ok = await login(username.trim(), password);
    if (ok) navigate('/chat');
  };

  return (
    <Box sx={{ width: '100vw', height: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default' }}>
      <Paper variant="outlined" sx={{ width: 360, p: 3, borderRadius: 2 }}>
        <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 700, mb: 0.5 }}>
          深流
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
          登录后继续会话
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField fullWidth size="small" label="用户名" value={username} onChange={(e) => setUsername(e.target.value)} sx={{ mb: 2 }} />
        <TextField fullWidth size="small" label="密码" type="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') submit(); }} sx={{ mb: 3 }} />
        <Button fullWidth variant="contained" disabled={loading || !username || !password} onClick={submit}>
          登录
        </Button>
      </Paper>
    </Box>
  );
};

export default LoginPage;
